import React from 'react'
import { observer } from 'mobx-react-lite'

import { Box } from '@material-ui/core'

import { MyTable } from './MyTable'
import { ScreenLoader } from './ScreenLoader'

import { useWbAccount } from '../hooks/routeHooks'
import { useLogic, useStore } from '../hooks/storeHook'
import { useBoolState, useLazyEffect } from '../hooks/commonHooks'

import { wbFilesColumns } from '../types/wbFilesColumns'

export const WbFilesTab =
  observer(() => {
    const account = useWbAccount()

    const {labelStore: {wbFiles}} = useStore()
    const {loadWbFiles} = useLogic()

    const [isLoading, /*setLoading*/, setLoaded] = useBoolState(true)

    useLazyEffect(() => loadWbFiles(account.id).finally(setLoaded))

    return (
      <Box width={'calc(100vw - 300px)'}>
        {
          isLoading
          ? <ScreenLoader/>
          :
          <MyTable
            table={wbFiles}
            columns={wbFilesColumns}
            labelNoRows={'Файлов нет'}
            labelNotFound={'Файлы не найдены'}
            labelRowsPerPage={'Файлов на странице:'}
          />
        }

        {
          wbFiles.totalRowCount >= 500 &&
          <small>
            Показаны последние 500 файлов.
          </small>
        }
      </Box>
    )
  })